import { Typography } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';
import { LegalHeading } from '@/components/legal/LegalHeading';
import { LegalText } from '@/components/legal/LegalText';

function ImprintRoute() {
  return (
    <ContainerLayout>
      <>
        <Typography sx={{ mb: 2 }} level="h1">
          Impressum
        </Typography>
        <LegalText>
          <b>Angaben gemäß § 5 TMG</b>
          <br />
          Ministerium für Verkehr Baden-Württemberg <br />
          Abteilung 5 <br />
          Dorotheenstraße 8 <br />
          70173 Stuttgart <br />
          <br />
          <Typography>
            <b>Kontakt</b>
            <br />
            E-Mail: <a href="mailto:poststelle@vm.bwl.de">poststelle@vm.bwl.de</a>
          </Typography>
        </LegalText>

        <Typography sx={{ mt: 4 }} level="h2">
          Haftungsausschluss
        </Typography>

        <LegalHeading>Haftung für Inhalte</LegalHeading>
        <LegalText>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
          Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
          übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
          eine rechtswidrige Tätigkeit hinweisen.
        </LegalText>
        <LegalText>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
          bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
          konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
          Inhalte umgehend entfernen.
        </LegalText>

        <LegalHeading>Haftung für Links</LegalHeading>
        <LegalText>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
          können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist
          stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
          Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
          Verlinkung nicht erkennbar.
        </LegalText>
        <LegalText>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
          Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
          entfernen.
        </LegalText>

        <LegalHeading>Urheberrecht</LegalHeading>
        <LegalText>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
          des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und
          Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </LegalText>
        <LegalText>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
          beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
          Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
          Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </LegalText>

        <LegalHeading>Datenschutz</LegalHeading>
        <LegalText>
          Informationen zum Datenschutz finden Sie in unserer <a href="/datenschutz">Datenschutzerklärung</a>.
        </LegalText>

        <Typography sx={{ mb: 1, mt: 2 }} level="h2">
          Quellenvermerk
        </Typography>

        <LegalText>Die Kartendarstellung beruht auf Grundlage von</LegalText>
        <ul>
          <li>
            <LegalText>
              <a href="https://www.lgl-bw.de/">LGL Baden-Württemberg</a>
            </LegalText>
          </li>
          <li>
            <LegalText>
              <a href="https://basemap.de/">basemap.de</a>
            </LegalText>
          </li>
        </ul>
      </>
    </ContainerLayout>
  );
}

export const Route = createFileRoute('/_authenticated/impressum')({
  component: ImprintRoute,
});
